"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../constants");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const Button = ({ onClick, classNamePrefix, label, isSubmitButton, isLoading }) => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    return (react_1.default.createElement("button", { className: `${classNamePrefix}-btn ${isLoading ? classNamePrefix + "-btn-loading" : ""}`, type: isSubmitButton ? "submit" : "button", onClick: () => !isSubmitButton && onClick && onClick(), disabled: isLoading, style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
        } },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: `${classNamePrefix}-spinner-btn`, icon: pro_solid_svg_icons_1.faSpinnerThird, spin: true, style: { visibility: isLoading ? "visible" : "hidden", position: "absolute", marginLeft: "auto", marginRight: "auto" } }),
        react_1.default.createElement("span", { className: `${classNamePrefix}-label-btn`, style: { visibility: isLoading ? "hidden" : "visible" } }, t(label)),
        react_1.default.createElement("div", { className: `${classNamePrefix}-image-btn`, style: { visibility: isLoading ? "hidden" : "visible" } })));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map